import { Box, Button, Typography } from "@mui/material";
import BasicRoute from "components/routes/BasicRoute";
import ExclusaoDialog from "entity/User/components/UserDelete/exclusao-dialog";
import firebaseUtil from "firebaseUtil";
import useNotification from "notification";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function RoutesMenusExclusaoDados() {
    return (
        <>
            <BasicRoute
                uid='ExclusaoDados'
                route="exclusao-dados"
                divider
                menuProps={{
                    text: "Conta e Dados",
                    sequence: "600009",
                    iconName: "ManageAccounts",
                }}
                element={<Exclusaodados />}
            />
        </>
    )
}

function Exclusaodados() {
    const [open, setOpen] = useState(false)
    const currentUser = firebaseUtil.getCurrentUser()
    const { showWarning, showSuccess } = useNotification();
    const navigate = useNavigate()


    const handleDeleteUser = async () => {
        try {
            await currentUser.delete().then(() => {
                showSuccess("Conta deletada com sucesso!", { autoClose: 1500, closeOnClick: true })
                setTimeout(() => {
                    navigate("/login")
                }, 1500)
            })
        } catch (error) {
            showWarning(error)
        }
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", px: 2 }}>
            <Typography variant="h1" sx={{ fontSize: 34, fontWeight: "bold", textAlign: "center", mt: 4 }}>Exclusão de Conta e Dados / e-Laudo</Typography>
            <Typography variant="h2" sx={{ fontSize: 24, fontWeight: "bold", textAlign: "center", mt: 4 }}>Etapas para realizar a exclusão de conta</Typography>
            <ol>
                <li>
                    <Button onClick={() => setOpen(true)} style={{ backgroundColor: "transparent" }} sx={{ border: "none", background: "transparent", color: "firebrick", padding: 0, boxShadow: "none", fontSize: 16, borderRadius: 4, ":hover": { background: "transparent", border: "none", boxShadow: "none" } }}>
                        Clique aqui para excluir sua conta
                    </Button>
                </li>
                <li>Digite a mensagem de confirmação e confirme a exclusão</li>
            </ol>
            <Typography variant="h2" sx={{ fontSize: 24, fontWeight: "bold", textAlign: "center", mt: 4 }}>Tipos de Dados Excluídos</Typography>
            <p>Ao solicitar a exclusão da conta, os seguintes dados serão excluídos permanentemente:</p>
            <ul>
                <li>Informações de perfil (nome, email, etc.)</li>
                <li>Histórico de atividades</li>
                <li>Dados salvos como: visitas, culturas, etc</li>
            </ul>

            <ExclusaoDialog open={open} handleClose={setOpen} acaoDeletar={handleDeleteUser} />
        </Box>
    )
}